import type { ToastStatus } from './toast.types'

interface IntentTokens {
  solid: string // border + intent color
  subtle: string // background
}

/** Token references per semantic intent. `loading` shares info tokens. */
const intentTokens: Record<ToastStatus, IntentTokens> = {
  info: {
    solid: 'var(--vui-feedback-info-solid)',
    subtle: 'var(--vui-feedback-info-subtle)',
  },
  success: {
    solid: 'var(--vui-feedback-success-solid)',
    subtle: 'var(--vui-feedback-success-subtle)',
  },
  warning: {
    solid: 'var(--vui-feedback-warning-solid)',
    subtle: 'var(--vui-feedback-warning-subtle)',
  },
  error: {
    solid: 'var(--vui-feedback-danger-solid)',
    subtle: 'var(--vui-feedback-danger-subtle)',
  },
  get loading() {
    return intentTokens.info
  },
}

export const intentStyle = Object.fromEntries(
  Object.entries(intentTokens).map(([intent, t]) => [
    intent,
    `--vui-toast-intent-color: ${t.solid}; background-color: ${t.subtle}; border: 1px solid ${t.solid};`,
  ]),
) as Record<ToastStatus, string>
